module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/title_ribbon_03-2bd8734cc2e1f852169786c1337e2645.png";